import { computed, inject, reactive, ref } from "vue";
import moment from "moment";
import FormInputComponent from "@/components/_shared/_partials/form-input/form-input.vue";

export default {
  name: "ContentCollectionGalleryItemComponent",
  components: {
    FormInputComponent,
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    preview: {
      type: Object,
      default: null,
      required: true
    },
    targetHeight: {
      type: Number,
      default: 250
    },
    targetWidth: {
      type: Number,
      default: 325
    },
    galleryIndex: {
      type: Number,
      default: 0
    }
  },
  emits: ['openpreview', 'changepreview'],
  setup(props, context) {
    const config = inject("config");
    const galleriesProvider = inject("galleriesProvider");
    const authProvider = inject("authProvider");

    const state = reactive({
      hasUser: computed(() => authProvider().hasUser),
      user: computed(() => authProvider().getUser),
      refs: ref([]),
      comments: ref([]),
      content: ref(null),
      loading: ref(false),
      item: ref(props.item),
      preview: ref(props.preview),
      showChangePreview: ref(false),
    });

    const previewItem = async preview => {
      if (props.preview && props.preview.id && props.preview.id === preview.id) {
        return false;
      }
      context.emit("preview", preview);
      const comments = await galleriesProvider().loadImageComments(
        preview.id,
        config
      );
      state.comments = comments.data.data;
      document.body.classList.add("koc-has-expanded");
    };

    const closePreview = () => {
      context.emit("preview", {});
      document.body.classList.remove("koc-has-expanded");

    };

    const isLiked = item => {
      if (!state.hasUser) {
        return false;
      }
      return state.user.likes.images.includes(item.id);
    };

    document.addEventListener("koc:gallery:commentAdded", async event => {
      context.emit("preview", props.preview);
      if (props.item.id === event.detail.image.id) {
        const item = await galleriesProvider().loadImage(
          props.preview.id,
          config
        );
        state.item = item;
        const comments = await galleriesProvider().loadImageComments(
          props.preview.id,
          config
        );
        state.comments = comments.data.data;
      }
    });

    document.addEventListener(
      "koc:gallery:updateLike",
      () => (state.loading = "like")
    );
    document.addEventListener("koc:gallery:updateLike:response", event => {
      if (props.item.id === event.detail.id) {
        state.item = event.detail;
        state.preview = event.detail;
      }
      setTimeout(() => {
        return (state.loading = false);
      }, 500);
    });

    return { state, previewItem, closePreview, isLiked };
  },
  methods: {
    like(details) {
      this.$emit("like", details);
    },
    showLogin() {
      this.closePreview();
      this.$emit("showlogin");
    },
    comment() {
      this.$emit("comment", this.state.content);
      this.clear();
    },
    changePreviewIndex(index) {
      this.$emit("changepreview", index);
    },
    clear() {
      this.$refs["textarea"].clear();
      this.state.content = null;
    },
    updateComment: async function(data) {
      let { value } = data;
      this.state.content = value;
    },
    formatTitle(title) {
      return title.split(".")[0];
    },
    isActivePreview(item) {
      if (!this.preview) {
        return false;
      }
      return this.preview.id === item.id;
    },
    imageLoaded(element) {
      const wrapper = element.target.closest(".koc-image-loading");
      wrapper.classList.remove("koc-image-loading");
      const block = wrapper.closest(
        ".koc-content-collection-gallery-item-block"
      );
      const bounding = block.getBoundingClientRect();
      const preview = block.childNodes[0];
      const thumbnail = preview.childNodes[2];
      thumbnail.style.width = `${bounding.width}px`;
      thumbnail.style.height = `${bounding.height}px`;
      thumbnail.style.top = `${bounding.top}px`;
      thumbnail.style.left = `${bounding.left}px`;
    },
    getWidth(media) {
      const targetHeight = 225;
      let width = (media.width * targetHeight) / media.height;
      return width;
    },
    getHeight(media) {
      const targetHeight = 225;
      const adjusted = `${(media.width * targetHeight) / media.height}`;
      const ratio = `${adjusted / media.width}`;
      return `${media.height * ratio}`;
    },
    getPadding(media) {
      return `${(media.height / media.width) * 100}`;
    },
    getScale(media) {
      return 0;
    },
    timeSince(timestamp) {
      return moment(String(timestamp)).format("MMM. D, YYYY");
    },
    scrollComments(id) {
      let comments = document.querySelector('#koc-item-comments' + id);
      comments.scrollIntoView({ behavior: 'smooth' });
    }
  }
};
